import { createContext, useContext, useState } from 'react';
import ToastContainer from '../component-lib/Toast/toast-container';

const ToastContext = createContext();

export function ToastContextProvider({ children }) {
  const [messages, setMessages] = useState([]);

  const showMessage = (message, type = 'info') => {
    const id = Math.random().toString(36).substring(2, 9);
    setMessages([
      ...messages,
      {
        show: true,
        id,
        message,
        type,
      },
    ]);

    setTimeout(() => {
      setMessages((messages) => {
        const messageToHide = messages.findIndex((m) => m.id === id);
        if (messageToHide === -1) {
          return messages;
        }
        const newMessages = [...messages];
        newMessages.splice(messageToHide, 1, {
          ...messages[messageToHide],
          show: false,
        });

        return newMessages;
      });
    }, 4000);
  };

  const contextValue = {
    showMessage,
    showError: (message) => showMessage(message, 'error'),
    showSuccess: (message) => showMessage(message, 'success'),
    showWarning: (message) => showMessage(message, 'warning'),
    showInfo: (message) => showMessage(message, 'info'),
  };

  return (
    <ToastContext.Provider value={contextValue}>
      {children}
      <ToastContainer
        messages={messages.reverse()}
        onDismiss={(messageId) => {
          setMessages((messages) => {
            const messageToHide = messages.findIndex((m) => m.id === messageId);
            if (messageToHide === -1) {
              return messages;
            }
            const newMessages = [...messages];
            newMessages.splice(messageToHide, 1, {
              ...messages[messageToHide],
              show: false,
            });

            return newMessages;
          });
        }}
      />
    </ToastContext.Provider>
  );
}

export function useToastContext() {
  return useContext(ToastContext);
}
